export default "__VITE_ASSET__Ri_SEEh6__"